var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"graphics container"},[_c('div',{staticClass:"head-data"},[_c('h6',{staticClass:"title"},[_vm._v(_vm._s(_vm.title)+" "+_vm._s(_vm.selectedYear))])]),_c('canvas',{staticClass:"canvas",attrs:{"id":_vm.idGraphic}})])}
var staticRenderFns = []

export { render, staticRenderFns }